import { planConstants } from "../actions/constants/planConstants";
import { success, failure, request } from "@/utils/constants";

const initialState = {
    plans: null,
    error: null,
    loading: false,
    success: false,
};

export const planList = (state = initialState, action: any) => {
    switch (action.type) {
        case planConstants.listPlanRequest:
            return {
                ...request,
            };
        case planConstants.listPlansSuccess:
            return {
                ...success,
                plans: action.payload,
            };
        case planConstants.listPlanFailure:
            return {
                ...failure,
            };
        default:
            return state;
    }
};


export const planCreate = (state = initialState, action: any) => {
    switch (action.type) {
        case planConstants.createPlanRequest:
            return {
                ...request,
            };
        case planConstants.createPlanSuccess:
            return {
                ...success,
                plan: action.payload,
            };
        case planConstants.createPlanFailure:
            return {
                ...failure,
            };
        default:
            return state;
    }
}

export const viewPlan = (state = initialState, action: any) => {
    switch (action.type) {
        case planConstants.viewPlanRequest:
            return {
                ...request,
            };
        case planConstants.viewPlanSuccess:
            return {
                ...success,
                plan: action.payload,
            };
        case planConstants.viewPlanFailure:
            return {
                ...failure,
            };
        default:
            return state;
    }
}

export const updatePlan = (state = initialState, action: any) => {
    switch (action.type) {
        case planConstants.updatePlanRequest:
            return {
                ...request,
            };
        case planConstants.updatePlanSuccess:
            return {
                ...success,
                plan: action.payload,
            };
        case planConstants.updatePlanFailure:
            return {
                ...failure,
            };
        default:
            return state;
    }
}